import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../services';
import { ROLES_TYPES } from '../enums';

const UserContext = createContext();

export const useContextInfo = () => {
  return useContext(UserContext);
};

export const ContextProvider = ({ children }) => {
  const updateInfo = (info) => {
    setUserInfo((prev) => ({
      ...prev,
      info
    }));
  };

  const getRoleForSite = () => {
    return (
      userInfo?.info?.siteRoles?.find((site) => site?.id+"" === selectedSite+"")?.roles ?? [ROLES_TYPES.USER]
    );
  }

  const isAdminForAnySites = (userData) => {
    return userData?.info?.siteRoles?.some(
      (site) => site.roles?.includes(ROLES_TYPES.SITE_ADMIN) ?? false
    );
  };

  const [userInfo, setUserInfo] = useState({ info: null, isAdminForAnySites: false, updateInfo });
  const [selectedSite, setSelectedSite] = useState(-1);
  const [isAdminForCurrentSite, setAdminForCurrentSite] = useState(false);

  useEffect(() => {
    setAdminForCurrentSite(getRoleForSite().includes(ROLES_TYPES.SITE_ADMIN));
  }, [selectedSite, userInfo]);

  useEffect(() => {
    if (!userInfo?.info) {
      try {
        api.user.getUserInfo().then(({ data }) => {
          setUserInfo((prev) => ({
            ...prev,
            info: data
          }));
        });
      } catch (e) {
        console.error('error ', e);
      }
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        userInfo,
        setUserInfo,
        selectedSite,
        setSelectedSite,
        getRoleForSite,
        isAdminForCurrentSite,
        isAdminForAnySites
      }}>
      {children}
    </UserContext.Provider>
  );
};

